const STEP = 15;
const ROWS = 60 / STEP;

function isTimeSpinner(options) {
  return !!(options.props && options.props.amPmMode && options.props.arrowControl && options.methods && options.methods.adjustSpinner);
}

export default {
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        if (!isTimeSpinner(this.$options)) return;
        const base = this.$options.methods;
        this.$options.methods = Object.assign({}, base, {
          handleScroll(type) {
            if (type !== 'minutes') return base.handleScroll.call(this, type);
            const height = this.typeItemHeight(type);
            const row = Math.round((this.$refs[type].wrap.scrollTop - (this.scrollBarHeight(type) * 0.5 - 10) / height + 3) / height);
            this.modifyDateField(type, Math.max(0, Math.min(row, ROWS - 1)) * STEP);
          },
          adjustSpinner(type, value) {
            return base.adjustSpinner.call(this, type, type === 'minutes' ? Math.floor(value / STEP) : value);
          },
          // Arrow keys on an open picker.
          scrollDown(step) {
            if (this.currentScrollbar !== 'minutes') return base.scrollDown.call(this, step);
            const now = (this.minutes - this.minutes % STEP + step * STEP + 60) % 60;
            this.modifyDateField('minutes', now);
            this.adjustSpinner('minutes', now);
            this.$nextTick(() => this.emitSelectRange(this.currentScrollbar));
          }
        });
      },
      created() {
        if (!isTimeSpinner(this.$options)) return;
        // The panels only take a change from the wheel while they are open, and some (date ranges)
        // hand the wheel the time to show on their next tick, so the floor waits until then.
        const shown = () => (this.$parent && this.$parent.visible && this.date ? this.date : null);
        this.$watch(() => { const d = shown(); return d ? d.getTime() : 0; }, () => {
          setTimeout(() => {
            const d = !this._isDestroyed && shown();
            const minutes = d ? d.getMinutes() : 0;
            if (minutes % STEP) this.modifyDateField('minutes', minutes - minutes % STEP);
          });
        }, { immediate: true });
      }
    });
  }
};
